import { render } from "./ChartD.vue?vue&type=template&id=41b10f24"
import script from "./ChartD.vue?vue&type=script&lang=ts"
export * from "./ChartD.vue?vue&type=script&lang=ts"
script.render = render

export default script